export const userRoutes = [
  // 프로필 페이지
  {
    path: '/app/profile',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },
  
  // 설정 페이지
  {
    path: '/app/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: { isFullScreen: false, requiresAuth: true }
  },

  // 공지사항
  {
    path: '/notices',
    name: 'notices',
    component: () => import('@/views/NoticesView.vue'),
    meta: { isFullScreen: false }
  },
  {
    path: '/notices/:id',
    name: 'notice-detail',
    component: () => import('@/views/NoticeDetailView.vue'),
    meta: { isFullScreen: false }
  },

  // 공개 프로필 페이지 (비로그인도 접근 가능)
  {
    path: '/u/:userId',
    name: 'public-profile',
    component: () => import('@/views/PublicProfileView.vue'),
    meta: { isFullScreen: false }
  }
]

